module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), (_vm.isShow) ? _c('v-top') : _vm._e(), _vm._v(" "), _c('v-body', {
    attrs: {
      "params": _vm.params,
      "type": _vm.type,
      "types": _vm.types
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1177fc31","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = 198
// module chunks = 2